import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';

import SuspenseLoader from 'src/components/SuspenseLoader';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

// Package routes
const Hajj = Loader(
  lazy(() => import('src/components/package/haj-umrah-package'))
);

const CreatePackage = Loader(
  lazy(() => import('src/components/AddOrEditHajUmrahPackage'))
);

const packagesRoutesAdmin = [
  {
    path: '',
    element: <Navigate to="hajj-umrah-package" replace />
  },
  {
    path: 'view-package',
    children: [
      {
        path: 'hajj-umrah-package',
        element: <Hajj />
      }
    ]
  },
  {
    path: 'add-or-update-package',
    element: <CreatePackage />
  }
];

export default packagesRoutesAdmin;
